import { writable } from "svelte/store";

//localStorage.workspace = JSON.stringify({})

let stored_subscription = localStorage.getItem("workspace_subscription");

if (!stored_subscription) {
    localStorage.setItem("workspace_subscription", JSON.stringify({}));
    stored_subscription = localStorage.getItem("workspace_subscription");
}

export const active_subscription = writable(JSON.parse(stored_subscription));

active_subscription.subscribe(value => {
    //stored_workspace = JSON.stringify(value)
    localStorage.setItem("workspace_subscription", JSON.stringify(value))
});